<template>
<DIV>
  <ItpText>{{ item.valid_from|date }}</ItpText>
<ItpText v-if="item.valid_to"> - {{ item.valid_to|date }}</ItpText>

<ItpText class="px-3">
  <span v-if="item.quantity != null">
    {{ item.quantity|number }} {{ item.unit_of_quantity || '' }} &times;
  </span>
   {{ item.amount|number }} {{ item.currency }} [{{ item.unit }}]
</ItpText>

</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractServiceFeeCard extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcContractServiceFeeCard", UcContractServiceFeeCard);

</script>